import React, { ReactNode } from 'react';
import { CommonModal } from '../../common/common-modal';
import { IConfirmProps } from '../../../../../infrastructure/alerts';
import { applyDefaultsToButtonProps, IAlertComponentProps } from '../alert-type';
import DefaultButton from '../../../default-button/default-button';
import { DefaultCloseModalButton } from '../../common/common-close-modal-buttons';
import { ButtonModifier } from '../../../../../infrastructure/helpers';

type IConfButtonProp = {
    modifiers?: ButtonModifier[];
    text: string | object | ReactNode;
    clickHandler?: () => void;
};

interface IFooterButtons {
    confirmButtonWithDefaults?: IConfButtonProp;
    extendConfirmButton?: IConfButtonProp;
    cancelButtonWithDefaults?: IConfButtonProp;
}

const FooterButtons = ({
    extendConfirmButton,
    confirmButtonWithDefaults,
    cancelButtonWithDefaults
}: IFooterButtons) => {
    const isExtendButtons = Boolean(extendConfirmButton);
    return (
        <div className={`buttons-block ${isExtendButtons ? 'buttons-block--space-between' : 'buttons-block--from-right' }`}>
            {
                isExtendButtons
                    ? (
                        <div className='buttons-block buttons-block--from-right'>
                            <DefaultButton
                                text={extendConfirmButton.text}
                                modifier={extendConfirmButton.modifiers}
                                onClick={extendConfirmButton.clickHandler}
                            />
                            <DefaultButton
                                   text={confirmButtonWithDefaults.text}
                                   modifier={confirmButtonWithDefaults.modifiers}
                                   onClick={confirmButtonWithDefaults.clickHandler}
                            />
                        </div>
                    ) : (
                        <DefaultButton
                            text={confirmButtonWithDefaults.text}
                            modifier={confirmButtonWithDefaults.modifiers}
                            onClick={confirmButtonWithDefaults.clickHandler}
                        />
                    )
            }
            <DefaultCloseModalButton
                text={cancelButtonWithDefaults.text}
                modifier={cancelButtonWithDefaults.modifiers}
            />
        </div>
    );
};

const ConfirmPopup = (props: IAlertComponentProps<IConfirmProps>) => {
    const { confirmButtonProps, extendConfirmButtonProps, cancelButtonProps } = props.popupProps;

    const confirmButtonWithDefaults = applyDefaultsToButtonProps(confirmButtonProps, 'Confirm', props.closeHandler);
    const extendConfirmButton = extendConfirmButtonProps && Object.keys(extendConfirmButtonProps).length !== 0 &&
        applyDefaultsToButtonProps(extendConfirmButtonProps, 'Confirm', props.closeHandler);
    const cancelButtonWithDefaults = applyDefaultsToButtonProps(cancelButtonProps, 'Cancel', props.closeHandler);

    return (
        <CommonModal
            className={props.popupProps.className}
            isOpen={true}
            title={props.popupProps.title}
            onRequestClose={cancelButtonWithDefaults.clickHandler}
            supressRenderingCrossIcon={!props.popupProps.renderCrossIcon}
            footer={
                <FooterButtons
                    extendConfirmButton={extendConfirmButton}
                    cancelButtonWithDefaults={cancelButtonWithDefaults}
                    confirmButtonWithDefaults={confirmButtonWithDefaults}
                />
            }
        >
            <div className='alert-body'>{props.popupProps.message}</div>
        </CommonModal>
    );
};

export { ConfirmPopup };